# TODO:CI where on earth should this go...
$ ->
  $("[data-remote-modal]").on "remote-modal:shown", (event, modal) ->
    $("form[data-contact-form]").submit (event) ->
      form = $(@)
      $.ajax
        url: form.attr("action")
        type: "POST"
        data: form.serialize()

      # Display confirmation overlay and fix height hack
      modal.modal.find("[data-modal-overlay]").removeClass("is-transparent")
      modal.modal.find("[data-modal-content]").css("height", ->
        $(@).height()
      )
      # Wait until render is complete before animating
      setTimeout(->
        modal.modal.find("[data-modal-content]").addClass("is-fixedHeight")
      , 0)

      event.preventDefault()

  if window.location.hash == "#contact"
    $("[data-remote-modal][href='/contact']").first().click()
